import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import './content_split_media_copy.css'

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));

